module.exports = __webpack_public_path__ + "media/components/country-flag/static/br-e86cfce11fc145f22a790a32271a5e52.svg";